import React, {useEffect, useState} from "react";
import {Business, CurrentUser, MenuItem, MenuSection, UserType} from "../../types/Types";
import "./../../App.css"
import DisplayListControl from "../../components/list/DisplayListControl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog, faPlus} from "@fortawesome/free-solid-svg-icons";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import MenuItemRow from "../../components/menu/MenuItemRow";
import {useNavigate} from "react-router";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
  menuSection: MenuSection,
  displayConfigButtons: boolean,
}

function MenuSectionRow(props: Props) {
  const navigate = useNavigate();
  const [displayList, setDisplayList] = useState<boolean>(true);
  const [menuItems, setMenuItems] = useState<Array<MenuItem>>([]);

  useEffect(() => {(async () => {
    let menuItemsToAdd = new Array<MenuItem>();
    const menuItemsCollection = query(
        collection(db, 'menu-items'),
        where("menuSection", "==", props.menuSection.id),
        orderBy("order", "asc"),
        limit(1000),
    );
    const menuItemsSnapshot = await getDocs(menuItemsCollection);
    menuItemsSnapshot.forEach((doc) => {
      menuItemsToAdd.push(doc.data() as MenuItem);
    });
    setMenuItems(menuItemsToAdd);
  })();
  }, []);

  const isAdmin = () => props.displayConfigButtons && props.currentUser.userType == UserType.LOCATION_MANAGER;

  return (
      <div className={`${props.displayConfigButtons ? 'list-bg' : ''}`}>
        {<div className={`${props.displayConfigButtons ? "list-title" : "list-title-compact"} ${displayList ? "" : "mb-0"} cursor-pointer`} onClick={() => {
          if(props.displayConfigButtons && props.currentUser.userType === UserType.LOCATION_MANAGER) {
            navigate(`/menu/section/${props.menuSection.id}/update`)
          } else {
            setDisplayList(!displayList)
          }
        }}>
          <b>{props.menuSection.description} {isAdmin() && <FontAwesomeIcon className={"ms-1 font-black"} icon={faCog}/>}</b>
          <DisplayListControl displayList={displayList} count={undefined} />
        </div>}
        {(displayList && menuItems.length > 0) && <div>
          {menuItems.map((menuItem, index) => (
              <div className={`cursor-pointer ${index == menuItems.length-1 ? 'mb-0' : 'mb-2'}`} onClick={() => {
               if(isAdmin()) {
                 navigate(`/menu/section/${props.menuSection.id}/item/${menuItem.id}/update`)
               }
              }}>
                 <MenuItemRow menuItem={menuItem} isAdmin={isAdmin()}/>
              </div>
          ))}
        </div>}
        {(menuItems.length === 0 && displayList) && <div className={"basic-box mt-2 mb-0"}>No menu items to display.</div>}
        {props.currentUser.userType == UserType.LOCATION_MANAGER && props.displayConfigButtons && <div onClick={() => navigate(`/menu/section/${props.menuSection.id}/create`)}>
            <div className={"primary-button pe-2 mt-2 mb-0 bg-blue"}>
                Create Menu Item
                <div className={"d-inline-block ms-2"}>
                    <FontAwesomeIcon icon={faPlus}/>
                </div>
            </div>
        </div>}
      </div>
  );
}

export default MenuSectionRow;
